import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d20bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidenav_wrap" }
const _hoisted_2 = { class: "navs" }

import navBtn from './components/NavBtn'
import TagLinkButton from './components/TagLinkButton'
import icon from '@/components/atoms/Icon'
import { checkPlatform } from '@/js/utils/util'
import FeedbackDialog from '@/components/molecules/FeedbackDialog'
import { displayReleasesNav } from '@/js/utils/environment'
import { computed, ref, watch } from 'vue'
import { useRoute, RouteRecordName, useRouter } from 'vue-router'
import { CameratagWithCameras } from '@/@types/typescript-axios'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const isNavOpen = ref<boolean>(checkPlatform() === 'lg')
const isChildNavOpen = ref<boolean>(checkPlatform() === 'lg')
const selectedNav = ref<string | RouteRecordName>('list')

// サイドナビのアクティブ表示用
if (route && route.name) {
  selectedNav.value = route.name
}

/**
 * サイドナビのアクティブ表示
 */
const activeNav = computed(() => (nav: string) => nav === selectedNav.value)

const tags = computed<CameratagWithCameras[]>(() => store.getters['tag/getHasCamerasTags'])
const permissions = computed(() => store.getters['auth/permissions'])
const settings = computed(() => store.getters['app/settings'])
const isTLT = computed(() => store.getters['app/isTLT'])

const isFeedbackDialog = computed<boolean>(() => checkPlatform() === 'sm' && isNavOpen.value)
const toggleClass = computed<string>(() => (isNavOpen.value === true ? 'open' : 'close'))
const hasTags = computed<boolean>(() => tags.value.length > 0)

/**
 * ヒートマップ表示
 */
const displayHeatMap = computed<boolean>(() =>
  permissions.value ? permissions.value.heatmap : false
)

/**
 * リリース情報表示
 */
const displayReleases = computed<boolean>(() => displayReleasesNav(settings.value.environmentMode))

const toggleNav = () => {
  isNavOpen.value = !isNavOpen.value
  // 子階層のナビも閉じる
  isChildNavOpen.value = false
}

const toggleTagNav = () => {
  isChildNavOpen.value = !isChildNavOpen.value
  // tagを開く場合は、親階層のナビを開く
  if (isChildNavOpen.value === true) {
    isNavOpen.value = true
  }
}

const changePage = () => {
  if (checkPlatform() === 'sm' && isNavOpen.value === true) {
    isNavOpen.value = false
  }
}

const showCameraList = (code: string) => {
  interface queryObj {
    [prop: string]: any
  }
  const query: queryObj = { filter: [], tags: [], func: [] }

  // タグコードが連携されている場合は、タグ情報を検索条件にセット
  if (code) {
    query.tags.push(code)
  }

  // viewがある場合URLに維持する
  if (route.query.view) {
    query.view = route.query.view
  }
  if (route.query.division) {
    query.division = route.query.division
  }
  router
    .push({
      name: 'list',
      params: { page: 1 },
      query: query,
    })
    .catch(() => {})

  changePage()
}

watch(route, (to) => {
  // サイドナビのアクティブ表示用
  if (to.name) {
    selectedNav.value = to.name
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["btn_toggle", _unref(toggleClass)]),
      onClick: toggleNav,
      "data-test": "side-nav-toggle"
    }, [
      _createVNode(_unref(icon), {
        type: "notes",
        color: "color-white"
      })
    ], 2),
    _createElementVNode("div", {
      id: "sidenav",
      class: _normalizeClass(["sidenav", _unref(toggleClass)]),
      "data-test": "side-nav"
    }, [
      _createElementVNode("nav", _hoisted_2, [
        (!_unref(hasTags))
          ? (_openBlock(), _createBlock(_unref(navBtn), {
              key: 0,
              class: "nav",
              icon: "videocam",
              link: "/list/1",
              label: _ctx.$t('side_nav.camera_list'),
              active: _unref(activeNav)('list'),
              onClick: changePage,
              "data-test": "side-nav-item-tags"
            }, null, 8, ["label", "active"]))
          : (_openBlock(), _createBlock(_unref(navBtn), {
              key: 1,
              class: "nav",
              icon: "videocam",
              label: _ctx.$t('side_nav.camera_list'),
              "has-child": true,
              "is-child-nav-open": isChildNavOpen.value,
              active: _unref(activeNav)('list'),
              onClickNavBtn: toggleTagNav
            }, null, 8, ["label", "is-child-nav-open", "active"])),
        _createElementVNode("div", {
          class: _normalizeClass(["child_nav", { open: isChildNavOpen.value }])
        }, [
          _createElementVNode("button", {
            class: "subNav",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCameraList())),
            "data-test": "side-nav-camera-list-all"
          }, _toDisplayString(_ctx.$t('side_nav.all')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
            return (_openBlock(), _createBlock(_unref(TagLinkButton), {
              key: tag.tag_code,
              tag: tag,
              onClick: ($event: any) => (showCameraList(tag.tag_code))
            }, null, 8, ["tag", "onClick"]))
          }), 128))
        ], 2),
        (_unref(displayHeatMap))
          ? (_openBlock(), _createBlock(_unref(navBtn), {
              key: 2,
              class: "nav",
              icon: "whatshot",
              link: "/heatmap",
              label: _ctx.$t('side_nav.heat_map'),
              active: _unref(activeNav)('heatmap'),
              onClick: changePage,
              "data-test": "side-nav-item-heatmap"
            }, null, 8, ["label", "active"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(navBtn), {
          class: "nav",
          icon: "psychology",
          link: "/video-semantic-search",
          label: _ctx.$t('side_nav.video_semantic_search'),
          active: _unref(activeNav)('video_semantic_search'),
          onClick: changePage,
          "data-test": "side-nav-item-video-semantic-search"
        }, null, 8, ["label", "active"]),
        (_unref(isTLT))
          ? (_openBlock(), _createBlock(_unref(navBtn), {
              key: 3,
              class: "nav",
              icon: "trending_up",
              link: "/person-tracking/results",
              label: _ctx.$t('side_nav.person_tracking'),
              active: _unref(activeNav)('person_tracking_results'),
              onClick: changePage,
              "data-test": "side-nav-item-person-tracking"
            }, null, 8, ["label", "active"]))
          : _createCommentVNode("", true),
        (_unref(isTLT))
          ? (_openBlock(), _createBlock(_unref(navBtn), {
              key: 4,
              class: "nav",
              icon: "build",
              link: "/operation-analysis/results",
              label: _ctx.$t('side_nav.operation_analysis'),
              active: _unref(activeNav)('operation_analysis_results'),
              onClick: changePage,
              "data-test": "side-nav-item-operation-analysis"
            }, null, 8, ["label", "active"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(navBtn), {
          class: "nav",
          icon: "settings",
          link: "/setting",
          label: _ctx.$t('side_nav.setting'),
          active: _unref(activeNav)('setting'),
          onClick: changePage,
          "data-test": "side-nav-item-setting"
        }, null, 8, ["label", "active"]),
        _createVNode(_unref(navBtn), {
          class: "nav",
          icon: "help_outline",
          link: "/help",
          label: _ctx.$t('side_nav.help'),
          active: _unref(activeNav)('help'),
          onClick: changePage,
          "data-test": "side-nav-item-help"
        }, null, 8, ["label", "active"]),
        (_unref(displayReleases))
          ? (_openBlock(), _createBlock(_unref(navBtn), {
              key: 5,
              class: "nav",
              icon: "list",
              link: "/releases",
              label: _ctx.$t('side_nav.releases'),
              active: _unref(activeNav)('releases'),
              onClick: changePage,
              "data-test": "side-nav-item-help"
            }, null, 8, ["label", "active"]))
          : _createCommentVNode("", true)
      ]),
      (_unref(isFeedbackDialog))
        ? (_openBlock(), _createBlock(_unref(FeedbackDialog), { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})